import Form from 'antd/es/form';
import { type FieldProps } from 'formik';
import type { FC } from 'react';
// @ts-ignore
import InputMask from 'react-input-mask';

const FormItem = Form.Item;

interface Props extends FieldProps {
  loading?: boolean;
  afterOnChange?: (value: any) => void;
  required?: boolean;
  className?: string;
}

const PhoneFormikInput: FC<Props> = ({
  field,
  form,
  required,
  loading,
  afterOnChange,
  className,
  ...props
}) => {
  const onChange = (value: any) => {
    form.setFieldValue(field.name, value.target?.value);
    afterOnChange?.(value);
  };

  const componentProps = {
    ...field,
    ...props,
    onChange,
    value: field.value,
    onBlur: () => {
      form.setFieldTouched(field.name);
    },
  };

  return (
    <FormItem required={required} style={{ marginBottom: 0 }}>
      <InputMask {...componentProps} className={className} mask="+1 (999) 999-9999" />
    </FormItem>
  );
};

export default PhoneFormikInput;
